// "No movement": the flight to the stop, then the camera stays exactly where it arrived for the whole stay.
// moveOptions:
//   travel  seconds the flight takes (default 3.2)
export default function still(o) {
  return { travel: Number.isFinite(o.travel) ? Math.max(0, o.travel) : 3.2, hold: false, step() {} };
}
